export const GET_USERS = 'src/pages/users/GET_USERS';
export const GET_USERS_SUCCESS = 'src/pages/users/GET_USERS__SUCCESS';
export const GET_USERS_FAILED = 'src/pages/users/GET_USERS__FAILED';

export const GET_CUSTOMERS = 'src/pages/users/GET_CUSTOMERS';
export const GET_CUSTOMERS_SUCCESS = 'src/pages/users/GET_CUSTOMERS__SUCCESS';
export const GET_CUSTOMERS_FAILED = 'src/pages/users/GET_CUSTOMERS__FAILED';

export const GET_ORGANS = 'src/pages/users/GET_ORGANS';
export const GET_ORGANS_SUCCESS = 'src/pages/users/GET_ORGANS__SUCCESS';
export const GET_ORGANS_FAILED = 'src/pages/users/GET_ORGANS__FAILED';

export const POST_ORGANS = 'src/pages/users/POST_ORGANS';
export const POST_ORGANS_SUCCESS = 'src/pages/users/POST_ORGANS__SUCCESS';
export const POST_ORGANS_FAILED = 'src/pages/users/POST_ORGANS__FAILED';

export const GET_USERS_WITH_ID = 'src/pages/users/GET_USERS_WITH_ID';
export const GET_USERS_WITH_ID_SUCCESS =
  'src/pages/users/GET_USERS_WITH_ID_SUCCESS';
export const GET_USERS_WITH_ID_FAILED =
  'src/pages/users/GET_USERS_WITH_ID_FAILED';

export const UPDATE_USER = 'src/pages/users/UPDALE_USER';
export const UPDATE_USER_SUCCESS = 'src/pages/users/UPDALE_USER_SUCCESS';
export const UPDATE_USER_FAILED = 'src/pages/users/UPDALE_USER_FAILED';

export const UPDATE_USER_STATUS = 'src/pages/users/UPDATE_USER_STATUS';
export const UPDATE_USER_STATUS_SUCCESS =
  'src/pages/users/UPDATE_USER_STATUS_SUCCESS';
export const UPDATE_USER_STATUS_FAILED =
  'src/pages/users/UPDATE_USER_STATUS_FAILED';

export const CREATE_USER = 'src/pages/users/CREATE_USER';
export const CREATE_USER_SUCCESS = 'src/pages/users/CREATE_USER_SUCCESS';
export const CREATE_USER_FAILED = 'src/pages/users/CREATE_USER_FAILED';

export const CANCEL_USERS = 'src/pages/users/CANCLE_USERS';
export const CANCEL_USERS_SUCCESS = 'src/pages/users/CANCLE_USERS_SUCCESS';
export const CANCEL_USERS_FAILED = 'src/pages/users/CANCLE_USERS_FAILED';
